export const cockpit = {
    Consulta: {
        "@consulta": {
            inicio: {
                momento: "",
                obj: {}
            },
            fim: {
                momento: "",
                obj: {}
            }
        },
    }
};
